// src/components/CtaFinal.jsx
// Bloco de CTA final, usado na Home e em Serviços.
import { SITE, whatsappLink } from "../data/site";

function CtaFinal() {
  return (
    <section className="cta-banner">
      <h2>Vamos filmar seu próximo imóvel?</h2>
      <p>
        Atendemos toda a {SITE.areaAtendimento}. Atendimento pelo WhatsApp de segunda a sexta,
        em horário comercial.
      </p>
      <a href={whatsappLink()} target="_blank" rel="noreferrer" className="btn btn-primary">
        Falar no WhatsApp
      </a>
    </section>
  );
}

export default CtaFinal;
